"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMainToken = void 0;
var _LaunchpadProvider_1 = require("../../LaunchpadProvider");
var _shared_1 = require("../../shared");
function useMainToken() {
    var mainToken = (0, _LaunchpadProvider_1.useLaunchpadProvider)().mainToken;
    var web3 = (0, _shared_1.useWeb3Provider)().web3;
    return (0, _shared_1.useERC20)(mainToken.address, web3);
}
exports.useMainToken = useMainToken;
